import { useSelectedSeller } from '@/modules/shared/hooks/use-selected-seller'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { shallow } from 'zustand/shallow'

import { useReportStore } from '@/modules/report/useReportsStore'

export type SearchFormPeriodData = {
  dtStart: string
  dtEnd: string
}

type UseSearchFormReportPeriod = {
  reportType: 'Client' | 'Product' | 'Commission'
}

export function useSearchFormReportPeriod({
  reportType,
}: UseSearchFormReportPeriod) {
  const selectedSeller = useSelectedSeller()
  const { loadSalesByClient, loadSalesByProduct, loadSalesCommission } =
    useReportStore(
      (state) => ({
        loadSalesByClient: state.loadSalesByClient,
        loadSalesByProduct: state.loadSalesByProduct,
        loadSalesCommission: state.loadSalesCommission,
      }),
      shallow,
    )

  const form = useForm<SearchFormPeriodData>({
    defaultValues: {
      dtStart: `${new Date().toISOString().slice(0, 8)}01`,
      dtEnd: new Date().toISOString().slice(0, 10),
    },
  })

  function handleLoadReport({ dtEnd, dtStart }: SearchFormPeriodData) {
    switch (reportType) {
      case 'Client':
        loadSalesByClient(dtStart, dtEnd, selectedSeller)
        break
      case 'Product':
        loadSalesByProduct(dtStart, dtEnd, selectedSeller)
        break
      case 'Commission':
        loadSalesCommission(dtStart, dtEnd, selectedSeller)
        break
    }
  }

  useEffect(() => {
    handleLoadReport(form.getValues())
  }, [selectedSeller])

  return {
    form,
    handleLoadReport,
  }
}
